import { createSagaActionTypes } from '../../../utils/actionFactory';

export const SET_RANGE = 'SET_RANGE';
export const UPDATE_RANGE = 'UPDATE_RANGE';

export const actions = createSagaActionTypes('EDIT_RANGE', [
  SET_RANGE,
  UPDATE_RANGE
]);
